import { gql } from 'apollo-angular';
import { Order } from '../../shared/entities/order/order';

export const ORDER_QUERY = gql`
query getOrderQuery(
  $orderId: UUID
)
{
  order: getOrder(
    id: $orderId
  )
  {
    id
    type
    number
    state
    archive
    commands
    location {
      name
    }
    lineItems {
      id
      text
      article {
        text
        number
        name
      }
      index
      indexText
      startDateTime
      endDateTime
      resourceAssignments {
        free
        text
        commands
        state
        protocols {
          id
          type
          state
          completedDateTime
          completedBy {
            firstName
            lastName
          }
          formControlTemplate
          task{
            id
            description
            type
            taskType {
              code
              name
              prefix
              icon
              color
            }
            state
            handlingType
            color
            dueDateTimePeriod {
              modifier
              dateTime
              fromDateTime
              toDateTime
              precision
            }
            assignment {
              assigneeId
              assignmentType
              typeLabel
              name
            }
            completedBy{
              firstName
              lastName
            }
            assignment {
              assigneeId
              assignmentType
              typeLabel
              name
              dueDateTimePeriod{
                  modifier
                  dateTime
                  fromDateTime
                  toDateTime
              }
            }
          }
        }
        startDateTime
        endDateTime
        customAttributes {
          id
          name
          value
          customAttributeDefinition {
            id
          }
          customAttributeSection {
            id
          }
        }
        resource {
          id
          text
          name
          number
          functions
        }
        effectiveSchedulingInformation{
          inHandlingType
          inDateTimePeriod {
            dateTime
            fromDateTime
            toDateTime
            modifier
          }
          inAddress {
            street
            houseNumber
            postalCode
            city
            country
            geocodingResultGrade
            name
            note
          }
          outHandlingType
          outDateTimePeriod {
            dateTime
            fromDateTime
            toDateTime
            modifier
          }
          outAddress{
            street
            houseNumber
            postalCode
            city
            country
            geocodingResultGrade
            name
            note
          }
          onSiteContacts {
            name
            firstName
            lastName
            phoneNumber
            mobileNumber
          }
          outDepot{
            name
            label
          }
          inDepot{
            name
            label
          }
        }
      }
    }
    customer {
      id
      type
      companyName
      companyNameExtension
      firstName
      lastName
      number
      email
    }
    customerOrderNumber
    orderer{
      firstName
      lastName
      name
    }
    note
    customAttributeSectionsViewModel{
      label
      customAttributes{
        type
        label
        value
        convertedValue
      }
    }
    aggregationRootId
    noteCount
    fileCount
    timeEntriesCount
  }
  tasksCount : getTasksCount(taskFilter: {
    orderId:  $orderId
  })
  tasksCountUnassigned : getTasksCount(taskFilter: {
    orderId:  $orderId, states:  [NEW, UNASSIGNED]
  })
  tasksCountAssigned : getTasksCount(taskFilter: {
    orderId:  $orderId, states:  [ASSIGNED]
  })
  tasksCountCompleted : getTasksCount(taskFilter: {
    orderId:  $orderId, states: [COMPLETED]
  })
  issuesCount: getIssuesCount(filter: {
    inwardEntityType: "Order",
    inwardEntityId: $orderId
  })
  openIssuesCount: getIssuesCount(filter: {
    inwardEntityType: "Order",
    inwardEntityId: $orderId,
    binaryStatus: "open"
  })
  closedIssuesCount: getIssuesCount(filter: {
    inwardEntityType: "Order",
    inwardEntityId: $orderId,
    binaryStatus: "closed"
  })
}
`;


export interface OrderQueryResponse {
  order: Order;
  loading: boolean;
  tasksCount: any;
  tasksCountAssigned: any;
  tasksCountUnassigned: any;
  tasksCountCompleted: any;
  commentsCount: any;
  issuesCount: number;
  openIssuesCount: number;
  closedIssuesCount: number;
}
